const serviceData = [
  {
    name:"Engine Diagnostics",
    desc:"OBD-II scan and live data analysis to pinpoint fault codes before they become serious. Full written report included.",
    time:"30 min",price:"From $49",
    feats:["Full OBD-II scan","Live sensor data","Written fault report","All makes & models"]
  },
  {
    name:"Minor Repairs",
    desc:"Hands-on repair work for small mechanical faults — belts, hoses, sensors, filters, and more. Fast turnaround guaranteed.",
    time:"Varies",price:"From $39",
    feats:["Belt & hose replacement","Sensor swaps","Filter changes","On-the-spot assessment"]
  },
  {
    name:"Roadside Assistance",
    desc:"Broke down? We'll come to you. Fast response times across Cairo — getting you back on the road is our priority.",
    time:"ASAP",price:"From $79",
    feats:["24/7 availability","Cairo-wide coverage","Jump starts & tyre changes","Towing if required"]
  },
  {
    name:"Battery Replacement",
    desc:"Battery health check and load testing. If it needs replacing, we carry the correct spec battery for your car in stock.",
    time:"20–30 min",price:"From $69",
    feats:["Load & health test","Same-day replacement","All car brands","Disposal of old battery"]
  },
  {
    name:"Oil Change",
    desc:"Fresh synthetic or semi-synthetic oil paired with a new filter. Keeps your engine protected and performing between services.",
    time:"45 min",price:"From $59",
    feats:["Synthetic & semi-synthetic","New filter included","Oil level & leak check","Disposal included"]
  },
  {
    name:"Tire Change",
    desc:"Full tire swap, balancing, and pressure check. We stock premium brands and handle all tyre sizes on the day.",
    time:"30–45 min",price:"From $39",
    feats:["All tyre sizes","Dynamic balancing","Pressure set to spec","TPMS reset"]
  }
];

let activeIdx = -1;

function togglePanel(cell, idx) {
  const allCells = document.querySelectorAll('.icon-cell');
  const panel = document.getElementById('sdp');
  const inner = document.getElementById('sdp-inner');

  if(activeIdx === idx) {
    // close
    panel.classList.remove('open');
    cell.classList.remove('active');
    activeIdx = -1;
    return;
  }

  allCells.forEach(c => c.classList.remove('active'));
  cell.classList.add('active');
  activeIdx = idx;

  const s = serviceData[idx];
  inner.innerHTML = `
    <div class="sdp-col">
      <div class="sdp-name">${s.name}</div>
      <p class="sdp-desc">${s.desc}</p>
      <a href="#booking" class="sdp-book" onclick="document.getElementById('sdp').classList.remove('open');document.querySelectorAll('.icon-cell').forEach(c=>c.classList.remove('active'));activeIdx=-1;">Book this service →</a>
    </div>
    <div class="sdp-col">
      <div class="sdp-label">Includes</div>
      <ul class="sdp-feats">
        ${s.feats.map(f=>`<li>${f}</li>`).join('')}
      </ul>
    </div>
    <div class="sdp-col">
      <div class="sdp-label">Average Time</div>
      <div class="sdp-val">${s.time}</div>
      <div class="sdp-label">Starting Price</div>
      <div class="sdp-val">${s.price}</div>
    </div>
  `;
  panel.classList.add('open');
}

// Tabs
function goTab(n) {
  document.querySelectorAll('.form-pane').forEach((p,i) => p.classList.toggle('active', i===n));
  document.querySelectorAll('.form-tab').forEach((t,i) => t.classList.toggle('active', i===n));
}
function nextTab(n) {
  if(n===0 && !document.querySelector('.sopt.on')) { alert('Please select at least one service.'); return; }
  if(n===1) {
    if(!document.getElementById('bookDate').value) { alert('Please select a date.'); return; }
    if(!document.querySelector('.tslot.on')) { alert('Please select a time slot.'); return; }
  }
  goTab(n+1);
}
function pickSlot(el) {
  if(el.classList.contains('off')) return;
  document.querySelectorAll('.tslot').forEach(s => s.classList.remove('on'));
  el.classList.add('on');
}
function showLocalConfirmation() {
  const ref = 'SRV-' + Math.random().toString(36).toUpperCase().slice(2,8);
  document.getElementById('refCode').textContent = ref;
  document.getElementById('pane2').style.display = 'none';
  const box = document.getElementById('confirmBox');
  box.style.display = 'block';
  box.scrollIntoView({behavior:'smooth',block:'center'});
}

async function submitForm() {
  const fn = document.getElementById('fName').value.trim();
  const ln = document.getElementById('lName').value.trim();
  const em = document.getElementById('email').value.trim();
  const ph = document.getElementById('phone').value.trim();
  const car = document.getElementById('car').value.trim();
  const yr = document.getElementById('yr').value.trim();
  const notes = document.getElementById('notes').value.trim();

  if(!fn || !em || !car) { alert('Please fill in your name, email, and car model.'); return; }

  const services = Array.from(document.querySelectorAll('.sopt.on .snm')).map(el => el.textContent.trim());
  if(!services.length) { alert('Please select at least one service.'); return; }

  const date = document.getElementById('bookDate').value;
  const timeEl = document.querySelector('.tslot.on');
  const time = timeEl ? timeEl.textContent.trim() : '';
  if(!date || !time) { alert('Please select a date and time.'); return; }

  const cfg = window.servoBooking || {};
  if(!cfg.productAvailable || !cfg.variantId) {
    // No Shopify product configured — fall back to local-only confirmation
    showLocalConfirmation();
    return;
  }

  const fullName = fn + (ln ? ' ' + ln : '');
  const vehicleFull = car + (yr ? ' (' + yr + ')' : '');
  const properties = {
    'Customer Name': fullName,
    'Email': em,
    'Phone': ph || '—',
    'Make & Model': car,
    'Year': yr || '—',
    'Vehicle': vehicleFull,
    'Services': services.join(', '),
    'Appointment Date': date,
    'Appointment Time': time
  };
  if(notes) properties['Notes'] = notes;

  const btn = document.querySelector('#pane2 .btn-next');
  const originalLabel = btn ? btn.textContent : '';
  if(btn) { btn.disabled = true; btn.textContent = 'Booking…'; }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        items: [{
          id: cfg.variantId,
          quantity: 1,
          properties: properties
        }]
      })
    });

    if(!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not create booking.');
    }

    // Add a cart note + attributes so booking details appear at the top of the order
    const ref = 'SRV-' + Math.random().toString(36).toUpperCase().slice(2,8);
    const noteLines = [
      'Booking ' + ref,
      'Customer: ' + fullName,
      'Phone: ' + (ph || '—'),
      'Vehicle: ' + vehicleFull,
      'Services: ' + services.join(', '),
      'Appointment: ' + date + ' at ' + time
    ];
    if(notes) noteLines.push('Notes: ' + notes);
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        note: noteLines.join('\n'),
        attributes: {
          'Booking Reference': ref,
          'Customer Name': fullName,
          'Phone': ph || '—',
          'Make & Model': car,
          'Year': yr || '—',
          'Vehicle': vehicleFull,
          'Services': services.join(', '),
          'Booking Date': date,
          'Booking Time': time
        }
      })
    }).catch(() => {});

    if(cfg.redirectToCheckout !== false) {
      window.location.href = cfg.checkoutUrl || '/checkout';
    } else {
      document.getElementById('refCode').textContent = ref;
      document.getElementById('pane2').style.display = 'none';
      const box = document.getElementById('confirmBox');
      box.style.display = 'block';
      box.scrollIntoView({behavior:'smooth',block:'center'});
    }
  } catch(e) {
    alert('Sorry, we could not complete your booking: ' + e.message);
    if(btn) { btn.disabled = false; btn.textContent = originalLabel || 'Confirm Booking'; }
  }
}
// Date min
const bd = document.getElementById('bookDate');
const tm = new Date(); tm.setDate(tm.getDate()+1);
bd.min = tm.toISOString().split('T')[0];

// Mobile menu
function toggleMobileMenu() {
  const menu = document.getElementById('mobileMenu');
  const btn = document.getElementById('hamburger');
  menu.classList.toggle('open');
  btn.classList.toggle('open');
}
function closeMobileMenu() {
  document.getElementById('mobileMenu').classList.remove('open');
  document.getElementById('hamburger').classList.remove('open');
}
